module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "contactDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.$t("admin.sendfeedback")))]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n\t\t" + _vm._s(_vm.$t("admin.feedbackinfo")) + "\n\t\t\n\t\t"), (_vm.type === 'contact') ? _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("name")))]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.body.name),
      callback: function($$v) {
        _vm.$set(_vm.body, "name", $$v)
      },
      expression: "body.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'contact') ? _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("email")))]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.body.email),
      callback: function($$v) {
        _vm.$set(_vm.body, "email", $$v)
      },
      expression: "body.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'contact') ? _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.phonenumber")))]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.body.phone),
      callback: function($$v) {
        _vm.$set(_vm.body, "phone", $$v)
      },
      expression: "body.phone"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.message")))]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.body.message),
      callback: function($$v) {
        _vm.$set(_vm.body, "message", $$v)
      },
      expression: "body.message"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.sendMessage()
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03f8209a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactDialog.vue
// module id = 406
// module chunks = 2